module.exports = __webpack_public_path__ + "static/media/Parabola.cab4c27d.jpg";